import { z } from 'zod';
import type { CurrencyToken } from '@sleed/bizcommerce-api';

/**
 * Currency edit form. Mirrors `CurrencyToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Pricing/Currencies/index.js): nm required ≤100, iso required ≤3,
 * fs (format string, e.g. "{0:N2}€") required ≤10, iv visible, si required sort order.
 */
export const currencySchema = z.object({
	id: z.number().optional(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	iso: z.string().trim().min(1, 'validation.required').max(3, 'validation.tooLong'),
	fs: z.string().trim().min(1, 'validation.required').max(10, 'validation.tooLong'),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int()
});

export type CurrencyFormValues = z.infer<typeof currencySchema>;

export const EMPTY_CURRENCY: CurrencyFormValues = {
	nm: '',
	iso: '',
	fs: '',
	iv: true,
	si: 0
};

export function tokenToForm(token: CurrencyToken): CurrencyFormValues {
	return {
		id: token.id,
		nm: token.nm ?? '',
		iso: token.iso ?? '',
		fs: token.fs ?? '',
		iv: token.iv ?? false,
		si: token.si ?? 0
	};
}

export function formToToken(form: CurrencyFormValues): CurrencyToken {
	return {
		id: form.id,
		nm: form.nm.trim(),
		iso: form.iso.trim(),
		fs: form.fs.trim(),
		iv: form.iv,
		si: form.si
	};
}
